import React from 'react';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import isObjectLike from 'lodash/isObjectLike';
import keys from 'lodash/keys';
import set from 'lodash/set';
export const useMutators = (externalMutators) => {
    const merge = React.useCallback((mutators, store) => {
        const mergeSpec = (a = {}, b) => {
            const result = cloneDeep(a);
            const getKeys = (parent) => {
                if (isObjectLike(parent)) {
                    return keys(parent).reduce((acc, parentKey) => {
                        const childKeys = getKeys(parent[parentKey]);
                        return [
                            ...acc,
                            ...(childKeys.length ? [] : [[parentKey]]),
                            ...childKeys.map((childKey) => [parentKey, ...childKey]),
                        ];
                    }, []);
                }
                return [];
            };
            getKeys(b).forEach((key) => {
                set(result, [key[0], 'value', ...key.slice(1)], get(b, key));
            });
            return result;
        };
        const mergeValuesOrErrors = (a = {}, b) => {
            const result = cloneDeep(a);
            Object.keys(b).forEach((key) => {
                set(result, [key, 'value'], b[key]);
            });
            return result;
        };
        return Object.assign(Object.assign(Object.assign(Object.assign({}, store), (mutators.errors
            ? { errors: mergeValuesOrErrors(store.errors, mutators.errors) }
            : {})), (mutators.values
            ? { values: mergeValuesOrErrors(store.values, mutators.values) }
            : {})), (mutators.spec ? { spec: mergeSpec(store.spec, mutators.spec) } : {}));
    }, []);
    const firstRenderRef = React.useRef(true);
    const [store, setStore] = React.useState(merge(externalMutators || {}, {}));
    const mutateDFState = React.useCallback((mutators) => {
        setStore((store) => merge(mutators, store));
    }, [setStore]);
    React.useEffect(() => {
        if (firstRenderRef.current) {
            firstRenderRef.current = false;
        }
        else if (externalMutators) {
            mutateDFState(externalMutators);
        }
    }, [externalMutators]);
    return { mutatorsStore: store, mutateDFState };
};
